(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const sizeGuideLinks = document.querySelectorAll('.product__size-guide');
    const sizeGuide = document.querySelector('.size-guides_wrapper');
    const sizeGuideClose = document.querySelector('.size-guides__close');
    const sizeGuideContent = document.querySelector('.size-guides');

    if (sizeGuideLinks.length > 0 && sizeGuide) {
      sizeGuideLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          sizeGuide.classList.toggle('active');
        });
      });

      sizeGuideClose.addEventListener('click', function (event) {
        event.preventDefault();
        sizeGuide.classList.remove('active');
      });

      sizeGuide.addEventListener('click', function (event) {
        if (event.target === sizeGuide) {
          sizeGuide.classList.remove('active');
        }
      });

      if (sizeGuideContent) {
        sizeGuideContent.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
